export interface getBannerByPageItemType {
  name: string;
  erid: string;
  code: string;
  animate: boolean;
  desktopSrc: string;
  mobileSrc: string;
  href: string;
  desktopWidth: number;
  mobileHeight: number;
  mobileWidth: number;
  desktopHeight: number;
}

export type BannerOptions = {
  widthDesktop: number;
  widthMobile: number;
  heightDesktop: number;
  heightMobile: number;
};

export type BannerType = {
  name?: string;
  href?: string;
  imageDesktop: string;
  imageMobile: string;
  handlerAction?: any;
  erid?: string;
  options?: BannerOptions;
};

export interface BannerSchema {
  banners: BannerType[];
  isLoaded: boolean;
}

export enum CodeBanner {
  BannerHomePage = 'baneryi-na-glavnoy',
  BannerLk = 'banner-lk',
  BannerReviews = 'banner-reviews',
  BannerShops = 'banner-shops',
  BannerShop = 'banner-shop',
}
